import { Instance } from 'mobx-state-tree'
import { GameLockModelBase } from './GameLockModel.base'

/* The TypeScript type of an instance of GameLockModel */
export interface GameLockModelType extends Instance<typeof GameLockModel.Type> {}

/* A graphql query fragment builders for GameLockModel */
export { selectFromGameLock, gameLockModelPrimitives, GameLockModelSelector } from './GameLockModel.base'

/**
 * GameLockModel
 */
export const GameLockModel = GameLockModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
